export type RouteGenerator<K extends string[] | undefined = undefined> =
  K extends string[]
    ? (segments: { [key in K[number]]: string }) => string
    : () => string;

const homepage: RouteGenerator = () => '/';

const pageBySlug: RouteGenerator<['slug']> = ({ slug }) => `/${slug}`;

const pageByUri: RouteGenerator<['uri']> = ({ uri }) =>
  `/${uri.replace(/^\//, '')}`;

const properties: RouteGenerator = () => '/biens';

const propertyType: RouteGenerator<['category']> = ({ category }) =>
  `/biens/${category}`;

const property: RouteGenerator<['category', 'slug']> = ({ category, slug }) =>
  `/biens/${category}/${slug}`;

const postCategory: RouteGenerator<['category']> = ({ category }) =>
  `/blog/${category}`;

const post: RouteGenerator<['category', 'slug']> = ({ category, slug }) =>
  `/blog/${category}/${slug}`;

const routeGenerator = {
  homepage,
  pageBySlug,
  pageByUri,
  properties,
  propertyType,
  property,
  postCategory,
  post,
};

export default routeGenerator;
